<!--  -->
<template>
  <div class="">
    <div class="secdbanner"></div>
    <div class="section">
      <div class="crumbsModel">
        您现在的位置：
        <a href="https://www.nstl.gov.cn">首页</a>
        <a class="no-cache" href="https://cart.nstl.gov.cn">申请单</a>
      </div>
      <div class="section clearfix">
        <div class="techprocess">
          <ul class="clearfix">
            <li class="width400 active">
              <span @click="gocart()"><b>1</b>选择文献</span>
              <u></u>
            </li>
            <li class="width400 active">
              <span><b>2</b>确认支付</span>
              <u></u>
            </li>
            <li class="width400">
              <span><b>3</b>支付成功</span>
              <u></u>
            </li>
          </ul>
        </div>
        <div class="borderbtom result_area">
          <p>确认申请</p>
        </div>
        <div class="tables result_area">
          <table class="table">
            <thead>
              <tr>
                <th width="60px">序号</th>
                <th>申请文献</th>
                <th width="300px">所属馆藏</th>
                <th width="80px">页码</th>
                <th width="120px">价格（元）</th>
              </tr>
            </thead>
            <tbody id="confirmation_order">
              <tr v-for="(d, index) in data.articleList" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <span class="text-align-left">
                    <a
                      class="text-pramis font_12"
                      :href="$store.state.home + (d.docOrderSysSource == 'NCOV2019' ? '/service/coronaviridae/paper_detail.html' : '/paper_detail.html') + '?id=' + d.articleId"
                      target="_blank"
                      >{{ d.articleTitle }}</a
                    >
                  </span>
                  <!--<span  id="spanundefined" v-show='d.discountType==3'><b class="drainageshopplabel">优惠免费</b></span>-->
                </td>
                <td>
                  {{ d.libraryLibName }}
                </td>
                <td>
                  <span>{{ d.docPages }}</span>
                </td>
                <td id="identif">
                  <span :class="'boldff6 ' + (d.discountType == 3 ? 'drainageChargeStyle' : '')" :ref="'charge' + d.docOrderId">￥{{ d.totalCharge.toFixed(2) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="notesdetailed result_area">
          <div class="Receaddress" style="margin-top: 10px">
            <span>投递方式：</span>
            <span class="commonse se1" style="margin-right: 20px" value="">
              <font color="#a2a2a2">{{ data.transWay }}</font>
            </span>
            <!-- <span>是否加急：</span>
							<span class="commonse se2"  value=""><font id="isVipFlag" color='#a2a2a2'></font></span>	 -->
          </div>
          <div class="Receaddress">
            <br />
            <span>
              邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱：
              <font style="color: #a2a2a2">{{ data.email }}</font>
            </span>
          </div>

          <div class="Receaddress">
            <br />
            <span>
              手&nbsp;&nbsp;机&nbsp;&nbsp;号：
              <font style="color: #a2a2a2" v-if="data.articleList">{{ data.articleList[0].phone }}</font>
            </span>
          </div>
          <div class="userinvoice">
            <!--  <div class="clearfix" id="invoice_info" :style="invoiceStyle">
              <h4 class="fl userleaving">发票信息：</h4>
              <div class="fl leftinvice">
                <p id="">
                  <font id="rise" color="#a2a2a2" v-if="invoice.invoiceType != '3' && invoice.title != null && invoice.title != undefined && invoice.title != ''">发票抬头：{{ invoice.title }}</font>
                </p>
                <p id="">
                  <font id="rise" color="#a2a2a2" v-if="invoice.invoiceType == '3'">发票抬头：个人</font>
                </p>
                <p id="">
                  <font id="duty" color="#a2a2a2" v-if="invoice.invoiceType != '3' && invoice.dutyparagraph != null && invoice.dutyparagraph != undefined && invoice.dutyparagraph != ''"
                    >纳税人识别号：{{ invoice.dutyparagraph }}</font
                  >
                </p>
                <p id="">
                  <font id="openBank" color="#a2a2a2" v-if="invoice.invoiceType != '3' && invoice.openBank != null && invoice.openBank != undefined && invoice.openBank != ''"
                    >开户银行：{{ invoice.openBank }}</font
                  >
                </p>
                <p id="">
                  <font id="bankAccount" color="#a2a2a2" v-if="invoice.invoiceType != '3' && invoice.bankAccount != null && invoice.bankAccount != undefined && invoice.bankAccount != ''"
                    >银行账号：{{ invoice.bankAccount }}</font
                  >
                </p>
                <p id="">
                  <font id="riseAddress" color="#a2a2a2" v-if="invoice.invoiceType != '3' && invoice.invoiceAddress != null && invoice.invoiceAddress != undefined && invoice.invoiceAddress != ''"
                    >地址：{{ invoice.invoiceAddress }}</font
                  >
                </p>
                <p id="">
                  <font id="telePhone" color="#a2a2a2" v-if="invoice.invoiceType != '3' && invoice.invoicePhone != null && invoice.invoicePhone != undefined && invoice.invoicePhone != ''"
                    >电话：{{ invoice.invoicePhone }}</font
                  >
                </p>
                <p id="">
                  <font id="mailedType" color="#a2a2a2" v-if="invoice.invoiceMode != '0' && invoice.mailedType != null && invoice.mailedType != undefined && invoice.mailedType != ''"
                    >发票获取方式：{{ invoice.mailedType }}</font
                  >
                </p>
                <p id="">
                  <font id="mailedAddress" color="#a2a2a2" v-if="invoice.invoiceMode != '0' && invoice.mailedAddress != null && invoice.mailedAddress != undefined && invoice.mailedAddress != ''"
                    >发票邮寄地址：{{ invoice.mailedAddress }}</font
                  >
                </p>
                <p id="">
                  <font id="mailedPhone" color="#a2a2a2" v-if="invoice.invoiceMode != '0' && invoice.mailedPhone != null && invoice.mailedPhone != undefined && invoice.mailedPhone != ''"
                    >发票邮寄电话：{{ invoice.mailedPhone }}</font
                  >
                </p>
                <p id="">
                  <font id="mailedPostcode" color="#a2a2a2" v-if="invoice.invoiceMode != '0' && invoice.mailedPostcode != null && invoice.mailedPostcode != undefined && invoice.mailedPostcode != ''"
                    >邮编：{{ invoice.mailedPostcode }}</font
                  >
                </p>
                <p id="">
                  <font
                    id="mailedAddress"
                    color="#a2a2a2"
                    v-if="invoice.invoiceMode == '0' && invoice.invoiceReceiveEmail != null && invoice.invoiceReceiveEmail != undefined && invoice.invoiceReceiveEmail != ''"
                    >发票接收邮箱：{{ invoice.invoiceReceiveEmail }}</font
                  >
                </p>
                <p id="">
                  <font
                    id="mailedPhone"
                    color="#a2a2a2"
                    v-if="invoice.invoiceMode == '0' && invoice.invoiceReceiveBackEmail != null && invoice.invoiceReceiveBackEmail != undefined && invoice.invoiceReceiveBackEmail != ''"
                    >备用邮箱：{{ invoice.invoiceReceiveBackEmail }}</font
                  >
                </p>
                <p id="">
                  <font
                    id="mailedPostcode"
                    color="#a2a2a2"
                    v-if="invoice.invoiceMode == '0' && invoice.invoiceReceivePhone != null && invoice.invoiceReceivePhone != undefined && invoice.invoiceReceivePhone != ''"
                    >发票接收手机：{{ invoice.invoiceReceivePhone }}</font
                  >
                </p>
                <p id="">
                  <font id="mailedName" color="#a2a2a2" v-if="invoice.mailedName != null && invoice.mailedName != undefined && invoice.mailedName != ''">联系人：{{ invoice.mailedName }}</font>
                </p>
              </div>
            </div> -->
            <div class="clearfix" id="remark_info">
              <h4 class="fl userleaving">用户留言：</h4>
              <div class="fl leftinvice">
                <p style="font-color: #a2a2a2" maxlength="200">
                  <font id="remark" color="#a2a2a2" v-if="data.articleList">{{ data.articleList[0].docUserMemo }}</font>
                </p>
              </div>
            </div>
          </div>

          <div class="faxbox userinvoice">
            <div class="clearfix">
              <h4 class="paymodebox js_paymodebox">
                支付方式：

                <el-radio name="pt" v-model="payType" label="balance" @change="changeActive('balance')">余额</el-radio>
                <el-radio name="pt" v-model="payType" label="bank" @change="changeActive('bank')" v-show="canBank">网上银行</el-radio>
                <el-radio name="pt" v-model="payType" label="weixin" @change="changeActive('weixin')" v-show="canWeiXin"> 微信支付</el-radio>
              </h4>
            </div>
          </div>

          <bank :style="bankShow" ref="bank"></bank>
          <div class="dialog-wrapper">
            <el-dialog title="特别提示" :visible.sync="tipShow" custom-class="status_change" :close-on-click-modal="false" class="status_change" :close-on-press-escape="false">
              <div class="notesbfamiddle">
                <p>1、请注意保存申请号，以便通过个人中心查询申请处理状态。</p>
                <p>2、请足额支付本次申请所需费用，超出部分将自动转入您的预付款账户。</p>
                <p>3、如未能正常收到您所申请的全文，可通过个人中心查询申请状态。</p>
                <p>4、选择自助获取方式申请的全文，可通过个人中心获取，有效期30天。</p>
                <p>5、注意保存网上支付号，以便通过个人中心查询支付状态。</p>
                <p>6、网上支付将通过首信易支付平台进行，要求用户必须先开通网上银行业务，具体操作方法参见首信易支付平台提供的相关银行规定。</p>
                <p>7、目前只支持人民币网上支付服务。</p>
                <p>8、如果您还有其他疑问，请通过服务热线与我们联系。电话800-900-8900；Email：service@nstl.gov.cn</p>
                <p>9、点击“首信易支付：按钮，将离开NSTL网络服务系统，进入首信易支付，请注意网上支付安全。</p>
                <p>
                  10、在您完成“首信易支付“后，建议您进行以下操作，以保证成功支付了申请：进入“我的NSTL”——“个人中心”——“申请查询”，在“请选择查询内容“中选择”网上支付申请“，输入申请号或按时间进行申请查询；如果申请状态是”未付款“，请点击”支付申请“，删除原申请，重新申请，并且一定要选择“预付款支付”，而不是“网上支付”。
                </p>
                <p>11、个人只提供电子发票。</p>
                <p>12、发票非实时开具，发票将在15个工作日内开具完成。</p>
                <p>13、如有其它问题，请咨询服务热线800-990-8900。</p>
              </div>
              <div slot="footer" class="dialog-footer" style="text-align: center;">
                <el-button @click="tipShow = false" style="background-color: rgba(22, 155, 213, 1);">
                  <font style="color: #FFFFFF;">确定</font>
                </el-button>
              </div>
            </el-dialog>

            <el-dialog
              title="微信扫码支付"
              :visible.sync="scanPay"
              :close-on-click-modal="false"
              @close="
                scanPay = false
                confirmPayDialog = true
              "
              width="451px"
              center
              :close-on-press-escape="false"
            >
              <div style="display: flex;justify-content: center;flex-direction: column;flex-wrap: nowrap;align-items: center;">
                <span>支付成功之前，请勿关闭二维码页面。</span>
                <br />
                <img style="width: 177px;height: 177px;margin-top: 0px;" :src="imageBase64" />
              </div>
            </el-dialog>

            <el-dialog title="提醒" :visible.sync="confirmPayDialog" :close-on-click-modal="false" class="status_change" width="430px" :show-close="false" :close-on-press-escape="false">
              <div style="display: flex;justify-content: center;flex-direction: row;flex-wrap: nowrap;align-items: center;">
                <img src="/static/cart/img/warn.svg" /> &nbsp;&nbsp;&nbsp;<font style="font-size: 16px;">请确认是否已支付完成？ </font>
              </div>
              <div slot="footer" style="display: flex;justify-content: center;flex-direction: row;flex-wrap: nowrap;align-items: center;">
                <el-button @click="paySuccess()" style="background-color: rgba(22, 155, 213, 1);">
                  <font style="color: #FFFFFF;">已支付</font>
                </el-button>
                <el-button @click="payFailed()" style="background-color: rgb(244, 246, 247);">
                  <font style="color: black">支付失败</font>
                </el-button>
              </div>
            </el-dialog>
          </div>

          <br />
          <div class="checkboxbox" :style="bankShow">
            <label style="font-size: 16px;"
              ><input type="checkbox" id="agree_hotTip" v-model="confirmTips" value="1" style="vertical-align:middle" />&nbsp;我已阅读<a
                href="javascript:void(0)"
                @click="showTips()"
                style="color: blue;font-size: 16px;"
                >《特别提示》</a
              ></label
            >
          </div>
          <br />
          <div class="Receaddress">
            <div class="confirmation">
              <p>
                <span
                  >总页数：<b id="totalPages">{{ data.totalPages }}</b></span
                >
                <span
                  >服务费：<b id="serviceCharge">￥{{ data.serviceCharge }}</b></span
                >
                <span
                  >复印费：<b id="copyCharge">￥{{ data.printingCharge }}</b></span
                >
                <!-- <span>版权费：<b id="copyrightCharge">￥0.00</b></span> -->
                <!-- <span>加急费：<b id="vipCharge">￥0.00</b></span> -->
                <!-- <span>运费：<b id="postCharge">￥0.00</b></span> -->
                <!-- <span>附加费：<b id="additionCharge">￥0.00</b></span> -->
                <span
                  >其他费用：<b id="otherCharge">￥{{ data.otherCharge }}</b></span
                >
                <span
                  >预扣费用：<b id="totalDoc_Price">￥{{ data.totalcharge }}</b></span
                >
                <span
                  >折扣率：<b id="discount">{{ data.discountValue }}%</b></span
                >
                <span
                  >余额：<b id="balance">￥{{ data.balance }}</b></span
                >
                <!-- <span>信用额：<b id="credit">￥0.00</b></span> -->
              </p>
            </div>
            <div class="invoice_sendwithgift">
              <span id="sec_count"><b>已选文献：</b>{{ count }}件</span>
              <span id="sec_discount"><b>已优惠：</b>￥{{ totalDiscountV.toFixed(2) }}</span>
              <span id="total_money"><b>总计：</b>￥{{ totalCharge }}</span>
              <a @click="confirm()" class="btn-1 js_btn_1" href="javascript:;">{{ confirmText }} </a>
              <a @click="gocart()" class="btn-2" href="javascript:;">取消 </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Radio, RadioGroup } from 'element-ui'
import balance from './Balance'
import bank from './Bank'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    balance,
    bank,
    Radio,
    RadioGroup
  },
  data() {
    //这里存放数据
    return {
      userTypeCanBank: false, //用户类型是否可以网银支付
      userTypeCanWeiXin: false, //用户类型是否可以微信支付
      canBank: false, //是否可以网银支付
      canWeiXin: false, //是否可以微信支付
      selectBalance: '', //余额支付选中样式
      balanceShow: '', //显示余额支付
      selectBank: '', //网银支付选中样式
      selectWeiXin: '', //微信支付选中样式
      bankShow: 'display:none', //显示网银支付
      tipShow: false,
      imageBase64: 'data:image/png;base64,',
      scanPay: false,
      confirmPayDialog: false,

      loading: false,
      tipStyle: 'border: none; display: none',
      invoiceStyle: 'display:none',
      orderInvoice: {},
      invoice: {},
      payType: 'balance',
      data: {},
      count: 0,
      totalDiscountV: 0,
      totalCharge: 0,
      confirmTips: '',
      queryTimer: '',
      confirmCanClick: true,
      confirmText: '确认申请'
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //弹出特别提示
    showTips() {
      this.tipShow = true
    },
    //切换支付方式
    changeActive(path) {
      console.log('>>>>>>>>>>>' + path)
      if (path == 'bank') {
        this.selectBank = 'active'
        this.selectBalance = ''

        this.selectWeiXin = ''
        this.bankShow = ''
        this.balanceShow = 'display:none'
        this.payType = 'bank'
      } else if (path == 'balance') {
        this.selectBank = ''
        this.selectBalance = 'active'
        this.selectWeiXin = ''
        this.bankShow = 'display:none'
        this.balanceShow = ''
        this.payType = 'balance'
        this.tipStyle = ''
      } else if (path == 'weixin') {
        this.selectBank = ''
        this.selectWeiXin = 'active'
        this.selectBalance = ''
        this.bankShow = ''
        this.balanceShow = 'display:none'
        this.payType = 'weixin'
        this.tipStyle = ''
      }
    },

    init() {
      this.changeActive('balance')
      this.confirmTips = ''
      this.getData()
      this.$nextTick(function() {
        let userInfo = this.$store.state.userInfo
        if (userInfo.userLibCode == 'CN000000' && (userInfo.usertype == '普通用户' || userInfo.usertype == '西部用户')) {
          this.canbank = true
        }
        console.log(JSON.stringify(userInfo))
      })
    },
    gocart() {
      this.$router.push('/cart/select')
    },
    getData() {
      //跳转到本页面后获取选择的文献数据
      let orderId = this.$route.query.orderId

      this.$loading.show()
      this.$http.get('/cart/getNonPayOrderList.shtml', { params: { orderId: orderId } }).then(response => {
        this.data = response.data.data
        this.$loading.hide()
        if (this.data == null) {
          this.$message
            .confirm(response.data.msg, '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning',
              center: false
            })
            .then(() => {
              window.location.href = this.$store.state.selfservice
            })
        }
        this.count = this.data.articleList.length
        let that = this
        this.data.articleList.forEach(function(item) {
          if (item.discountType == 3) {
            that.totalDiscountV += item.orderCost.preCharge
            //item.totalCharge = 0.00;
          }
        })

        this.totalCharge = Math.abs(this.data.totalcharge - this.totalDiscountV).toFixed(2)
        if (this.totalCharge == 0) {
          //文献金额为0不能使用网银支付
          this.canBank = false
          this.canWeiXin = false
          this.changeActive('balance')
        } else {
          let userInfo = sessionStorage.getItem('uf') ? JSON.parse(sessionStorage.getItem('uf')) : null
          // console.log(userInfo)
          if (userInfo != null && userInfo != undefined) {
            //判断用户是否可以进行网银支付
            if (userInfo.userlibcode == 'CN000000' && (userInfo.usertype == '普通用户' || userInfo.usertype == '西部用户')) {
              this.canBank = true
              this.canWeiXin = true
            }
          }
        }
        console.log(this.canBank + '  ' + this.canWeiXin)
      })
    },
    confirm() {
      if (!this.confirmCanClick) {
        return false
      }
      if (this.confirmTips != '1' && (this.payType == 'bank' || this.payType == 'weixin')) {
        this.$message.alert('请勾选阅读提示', '信息', { customClass: 'msgbox' })
        return false
      }
      if (!this.$refs.bank.submitValidate() && (this.payType == 'bank' || this.payType == 'weixin')) {
        this.$message.alert('请先完善发票信息', '信息', { customClass: 'msgbox' })
        return false
      }
      this.invoice = this.$refs.bank.getInvoiceData()
      console.log(this.invoice)
      // return
      this.confirmCanClick = false
      this.confirmText = '支付中。。。'
      let that = this
      setTimeout(function() {
        that.confirmCanClick = true
        that.confirmText = '确认申请'
      }, 5000)
      this.$loading.show()
      //发送支付请求
      if (this.payType == 'balance') {
        this.balancePay()
      } else if (this.payType == 'bank') {
        if (this.totalCharge == 0) {
          //金额为0使用余额支付
          this.balancePay()
        } else {
          this.bankPay()
        }
      } else if ((this.payType = 'weixin')) {
        if (this.totalCharge == 0) {
          //金额为0使用余额支付
          this.balancePay()
        } else {
          this.weixinPay()
        }
      }
    },
    //余额支付
    balancePay: function() {
      this.$http
        .post('/cart/balancePay.shtml', this.$queryString.stringify({ orderId: this.data.orderId }), {
          emulateJSON: true
        })
        .then(response => {
          this.$loading.hide()
          if (response.data.code == 0) {
            this.$router.push('success')
          } else if (response.data.code == 1 && response.data.data != null) {
            this.$message.alert(response.data.msg)
          } else {
            this.$router.push({
              name: 'fail',
              params: { payResponse: JSON.stringify(response.data), orderId: this.data.orderId }
            })
          }
        })
    },
    //首信易网银支付
    bankPay: function() {
      let docOrderIds = new Array()

      for (let i = 0; i < this.count; i++) {
        let docOrderId = this.data.articleList[i].docOrderId
        if (this.data.articleList[i].discountType == 0) {
          docOrderIds.push(docOrderId)
        }
      }
      //封装提交的发票信息
      let orderInvoice = {
        purchaseName: this.invoice.title,
        purchaseNumber: this.invoice.dutyparagraph,
        purchaseBank: this.invoice.openBank ? '' : this.invoice.openBank + ' ' + this.invoice.bankAccount ? '' : this.invoice.bankAccount,
        purchaseAddress: this.invoice.invoiceAddress ? '' : this.invoice.invoiceAddress + ' ' + this.invoice.invoicePhone ? '' : this.invoice.invoicePhone,
        mailedName: this.invoice.mailedName,
        mailedAddress: this.invoice.mailedAddress,
        mailedPhone: this.invoice.mailedPhone,
        mailedPostcode: this.invoice.mailedPostcode,
        invoiceType: this.invoice.invoiceType,
        mailedType: this.invoice.mailedType,
        invoiceMode: this.invoice.invoiceMode,
        invoiceReceiveEmail: this.invoice.invoiceReceiveEmail,
        invoiceReceiveBackEmail: this.invoice.invoiceReceiveBackEmail,
        invoiceReceivePhone: this.invoice.invoiceReceivePhone
      }
      if (orderInvoice.invoiceMode == '0') {
        //电子发票
        orderInvoice.mailedAddress = ''
        orderInvoice.mailedPhone = ''
        orderInvoice.mailedPostcode = ''
      } else {
        orderInvoice.invoiceReceiveEmail = ''
        orderInvoice.invoiceReceiveBackEmail = ''
        orderInvoice.invoiceReceivePhone = ''
      }
      if (orderInvoice.invoiceType == '3') {
        //个人发票
        orderInvoice.purchaseName = '个人'
      }

      this.$http
        .post('/cart/webPay.shtml', { invoice: orderInvoice, orderId: this.$route.query.orderId })
        .then(response => {
          //  sessionStorage.removeItem("invoice")
          this.$loading.hide()
          if (response.data.code == 0) {
            //跳转支付
            if (response.data.data.indexOf('https://payment.5upay.com') == -1) {
              this.$message
                .confirm('您有尚未完成的扫码支付订单，是否继续支付？', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  type: 'warning',
                  center: false
                })
                .then(() => {
                  if (this.$store.state.userInfo.userlibcode == 'CN000000') {
                    this.imageBase64 = this.imageBase64 + response.data.data
                    this.scanPay = true
                    //this.$messageTips.show(response.data.data, 2)
                  } else {
                    //this.$messageTips.show(response.data.data, 1)
                    this.imageBase64 = this.imageBase64 + response.data.data
                    this.scanPay = true
                  }
                  this.queryTimer = setInterval(this.queryWXPay, 3000)
                })
              return
            }
            window.location.href = response.data.data
          } else if (response.data.code == 2) {
            //已经支付成功
            this.$message.alert(response.data.msg)
            this.gocart()
          } else {
            //支付失败
            this.$message.alert('支付失败，请转至个人中心重新支付！')
          }
        })
        .catch(error => {
          //支付失败，跳转支付失败页面
          this.$loading.hide()
          var tempData = {}
          var param = { code: 1, msg: '支付失败', count: 0, data: {}, lcode: 1 }

          for (var i = 0; i < this.data.articleList.length; i++) {
            let item = this.data.articleList[i]
            tempData[item.docOrderId] = 0
          }
          param.data = tempData
          this.$router.push({
            name: 'fail',
            params: { payResponse: JSON.stringify(param), orderId: this.data.orderId }
          })
        })
    },
    //首信易微信扫码支付
    weixinPay: function() {
      let docOrderIds = new Array()
      for (let i = 0; i < this.count; i++) {
        let docOrderId = this.data.articleList[i].docOrderId
        if (this.data.articleList[i].discountType == 0) {
          docOrderIds.push(docOrderId)
        }
      }
      //封装提交的发票信息
      let orderInvoice = {
        purchaseName: this.invoice.title,
        purchaseNumber: this.invoice.dutyparagraph,
        purchaseBank: this.invoice.openBank ? '' : this.invoice.openBank + ' ' + this.invoice.bankAccount ? '' : this.invoice.bankAccount,
        purchaseAddress: this.invoice.invoiceAddress ? '' : this.invoice.invoiceAddress + ' ' + this.invoice.invoicePhone ? '' : this.invoice.invoicePhone,
        mailedName: this.invoice.mailedName,
        mailedAddress: this.invoice.mailedAddress,
        mailedPhone: this.invoice.mailedPhone,
        mailedPostcode: this.invoice.mailedPostcode,
        invoiceType: this.invoice.invoiceType,
        mailedType: this.invoice.mailedType,
        invoiceMode: this.invoice.invoiceMode,
        invoiceReceiveEmail: this.invoice.invoiceReceiveEmail,
        invoiceReceiveBackEmail: this.invoice.invoiceReceiveBackEmail,
        invoiceReceivePhone: this.invoice.invoiceReceivePhone
      }
      if (orderInvoice.invoiceMode == '0') {
        //电子发票
        orderInvoice.mailedAddress = ''
        orderInvoice.mailedPhone = ''
        orderInvoice.mailedPostcode = ''
      } else {
        orderInvoice.invoiceReceiveEmail = ''
        orderInvoice.invoiceReceiveBackEmail = ''
        orderInvoice.invoiceReceivePhone = ''
      }
      if (orderInvoice.invoiceType == '3') {
        //个人发票
        orderInvoice.purchaseName = '个人'
      }

      this.$http.post('/cart/weixinPay.shtml', { invoice: orderInvoice, orderId: this.$route.query.orderId }).then(response => {
        this.$loading.hide()
        if (response.data.code == 0) {
          //跳转支付
          if (response.data.data.indexOf('https://payment.5upay.com') > -1) {
            this.$message
              .confirm('您有尚未完成的网银支付订单，是否继续支付？', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                type: 'warning',
                center: false
              })
              .then(() => {
                window.location.href = response.data.data
              })
            return
          }
          if (this.$store.state.userInfo.userlibcode == 'CN000000') {
            // this.$messageTips.show(response.data.data, 2)
            this.imageBase64 = this.imageBase64 + response.data.data
            this.scanPay = true
          } else {
            //this.$messageTips.show(response.data.data, 1)
            this.imageBase64 = this.imageBase64 + response.data.data
            this.scanPay = true
          }
          this.queryTimer = setInterval(this.queryWXPay, 3000)
        } else if (response.data.code == 2) {
          //已经支付成功
          this.$message.alert(response.data.msg)
          this.gocart()
        } else {
          //支付失败
          this.$message.alert('获取支付链接失败，请重试！')
          //this.$messageTips.hide()
        }
      })

      // this.$message.alert('<img src="https://www.nstl.gov.cn/img/QRcode1.png" />', '信息', { customClass: 'msgbox' });
      //   this.$loading.hide()
      /* this.$http
          .post('/cart/weixinPay.shtml', { docOrderIds: docOrderIds, invoice: orderInvoice })
          .then((response) => {
   
            this.$loading.hide()
           
          })
          .catch((error) => {//支付失败，跳转支付失败页面
            this.$loading.hide()
        //    var tempData = {}
        //    var param = {"code":1,"msg":"支付失败","count":0,"data":{},"lcode":1}
       //     for(var i=0;i<this.data.articleList.length;i++){
       //       let item = this.data.articleList[i]
       //       tempData[item.docOrderId]=0
       //     }
      //      param.data = tempData
       //     this.$router.push({
      //        name: 'fail',
      //        params: { payResponse: JSON.stringify(param), orderId: this.data.orderId },
      //      })
          })*/
    },
    queryWXPay() {
      if (!this.scanPay) {
        clearInterval(this.queryTimer)
      }
      this.$http.get('/cart/queryWXPay.shtml?orderId=' + this.data.orderId).then(response => {
        if (response.data.msg == 'SUCCESS') {
          clearInterval(this.queryTimer)
          this.scanPay = false
          this.$router.push({
            name: 'success',
            query: { requestId: response.data.data }
          })
        } else if (response.data.msg == 'ERROR' || response.data.msg == 'CLOSED' || response.data.msg == 'REVOKED' || response.data.msg == 'PAYERROR' || response.data.msg == 'REFUND') {
          clearInterval(this.queryTimer)
          this.scanPay = false
          var tempData = {}
          var param = { code: 1, msg: '支付失败', count: 0, data: {}, lcode: 1 }

          for (var i = 0; i < this.data.articleList.length; i++) {
            let item = this.data.articleList[i]
            tempData[item.docOrderId] = 0
          }
          param.data = tempData
          this.$router.push({
            name: 'fail',
            params: { payResponse: JSON.stringify(param), orderId: this.data.orderId }
          })
        }
      })
    },

    paySuccess() {
      this.$http.get('/cart/queryWXPay.shtml?orderId=' + this.data.orderId).then(response => {
        if (response.data.msg == 'SUCCESS') {
          clearInterval(this.queryTimer)
          this.$router.push({
            name: 'success',
            query: { requestId: response.data.data }
          })
        } else {
          var tempData = {}
          var param = { code: 1, msg: '支付失败', count: 0, data: {}, lcode: 1 }
          for (var i = 0; i < this.data.articleList.length; i++) {
            let item = this.data.articleList[i]
            tempData[item.docOrderId] = 0
          }
          param.data = tempData
          this.$router.push({
            name: 'fail',
            params: { payResponse: JSON.stringify(param), orderId: this.data.orderId }
          })
        }
      })
    },

    payFailed() {
      var tempData = {}
      var param = { code: 1, msg: '支付失败', count: 0, data: {}, lcode: 1 }

      for (var i = 0; i < this.data.articleList.length; i++) {
        let item = this.data.articleList[i]
        tempData[item.docOrderId] = 0
      }
      param.data = tempData
      this.$router.push({
        name: 'fail',
        params: { payResponse: JSON.stringify(param), orderId: this.data.orderId }
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(function() {
      this.$http.get('/cart/queryPayUrl.shtml?orderId=' + this.$route.query.orderId).then(response => {
        if (response.data.data) {
          this.confirmPayDialog = true
          if (response.data.data.indexOf('https://payment.5upay.com') > -1) {
            this.payType = 'bank'
          } else {
            this.payType = 'weixin'
          }
        }
      })
      this.init()
      /*  if(!this.$store.state.isLogin) {
      console.log("1111111111")
      this.$router.replace("/cart/select")
    }else{
      this.init()
    } */
    })
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}

Array.prototype.remove = function(v) {
  let flag = false
  for (let i = 0; i + 1 < this.length; i++) {
    if (this[i] == v) {
      flag = true
    }
    if (flag) {
      this[i] = this[i + 1]
    }
  }
  if (flag) {
    this.length -= 1
  }
}
</script>
<style>
.status_change .el-dialog__header {
  background-color: rgb(242, 242, 242);
}
</style>

<style scoped>
.msgbox {
  width: 260px;
}

.none {
  display: none;
}

.block {
  display: inline;
}

.drainageshopplabel {
  display: inline-block;
  height: 20px;
  border-radius: 10px;
  border: 1px solid red;
  padding: 0 12px;
  margin-left: 7px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: red;
}

.drainageChargeStyle {
  text-decoration: line-through;
  text-decoration-color: black;
  text-decoration-thickness: 0.1em;
}
</style>



// WEBPACK FOOTER //
// src/views/cart/Pay.vue